import { Matrix3, Vector2, Vector2Tuple } from 'three';

import { toVector2 } from '@spazious/dollhouse-three';

const _center = new Vector2();
const _vertex = new Vector2();

export const getOrientedBox2Corners = (
  center: Vector2Tuple,
  size: Vector2Tuple,
  theta: number
): Vector2Tuple[] => {
  const halfSizeX = size[0] / 2;
  const halfSizeY = size[1] / 2;

  const m = new Matrix3().makeRotation(theta);

  toVector2(center, _center);

  return [
    _vertex.set(-halfSizeX, -halfSizeY).applyMatrix3(m).add(_center).toArray(),
    _vertex.set(halfSizeX, -halfSizeY).applyMatrix3(m).add(_center).toArray(),
    _vertex.set(halfSizeX, halfSizeY).applyMatrix3(m).add(_center).toArray(),
    _vertex.set(-halfSizeX, halfSizeY).applyMatrix3(m).add(_center).toArray(),
  ];
};

export default getOrientedBox2Corners;
